<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Cari İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="info" @click="SayfaYukle" :disabled="lo">yenile</el-button>
        <el-button size="small" type="primary" @click="BolgeEkle" :disabled="lo">Cari Ekle</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.adi.toLowerCase().includes(Kelime.toLowerCase()))"

          :height="Height">
        <el-table-column label="#" prop="id" width="75"></el-table-column>
        <el-table-column label="Cari Adı" prop="adi"></el-table-column>
        <el-table-column label="Telefon" prop="telefon"></el-table-column>
        <el-table-column label="Email" prop="email"></el-table-column>
        <el-table-column label="Vergi No" prop="vno"></el-table-column>
        <el-table-column label="Vergi Dairesi" prop="vdaire"></el-table-column>
        <el-table-column label="Banka Adı" prop="banka"></el-table-column>
        <el-table-column label="Iban" prop="iban"></el-table-column>
        <el-table-column label="Adres" prop="adres"></el-table-column>
        <el-table-column
            align="right" label="Bakim" prop="Grup" width="250" class-name="tablearama">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">Düzenle
            </el-button>
          </template>

          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Modal :Bilgi="Bilgi" :Tur="Tur" :Durum="ModalDurum" @Durum="SayfaYukle"></Modal>
  </div>
</template>

<script>
import Modal from "./Comp/Modal";

export default {
  components: {Modal},
  data() {
    return {
      lo: false,
      ModalDurum: false,
      Tur: null,
      Kelime: "",
      Height: null,
      Bilgi: null,
      Liste: null
    }
  },
  methods: {
    TableSecim(e) {
      //this.$router.push('/cari/' + e.id)
      //this.Bilgi
    },
    SayfaYukle() {
      this.lo = true
      this.ModalDurum = false
      this.$store.dispatch("Get", {path: 'cari'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Data
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    handleEdit(index, row) {
      this.Tur = 'Put'
      this.Bilgi = row
      this.ModalDurum = true
      this.$forceUpdate()

    },
    handleDelete(index, row) {
      this.$store.dispatch("Delete", {path: 'cari/' + row.id})
          .then(response => {
            if (response.Durum === "OK") {
              this.$notify.info({
                title: response.Mesaj,
                customClass: 'info'
              });
              this.DetayModalDurum = false
              this.SayfaYukle()
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    BolgeEkle() {
      this.ModalDurum = true
      this.Bilgi = {};
      this.Tur = 'Post'

    }
  },
  created() {
    this.$store.dispatch("title", "Cari İşlemleri");
    this.SayfaYukle();
    this.Height = window.innerHeight - 111
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/cari/liste.vue